export default {"src":"/_next/static/media/telephone.ee48f9b1.svg","height":14,"width":101,"blurWidth":0,"blurHeight":0};